import { ALERT_ICONS } from "./constants";
import { IAlert } from "./interface";
import './alert.scss';

export const Alert = ({ children, type = "success" }: IAlert) => (
  <div className={`Alert ${type}`} data-testid="alertContainer">
    <img {...ALERT_ICONS[type]} />
    <div className="Alert__content">
      <p>{children}</p>
    </div>
  </div>
);
